module.exports = __webpack_public_path__ + "img/green_button_bg_mid.0258227f.png";